import React from 'react';
import { useTheme as useMuiTheme } from '@mui/material/styles';
import MDBox from 'components/MDBox';

export function LocalErrorBox({ message }) {
  const theme = useMuiTheme();
  if (!message) return null;

  return (
    <MDBox
      sx={{
        p: 1.25,
        borderRadius: '16px',
        border: `1px solid ${theme.palette.error.main}`,
        color: theme.palette.error.main,
        background: 'rgba(244,67,54,.06)',
      }}
    >
      {message}
    </MDBox>
  );
}
